import cn from "classnames";
import { FC, useState, MouseEvent } from "react";
import { Slot } from "src/components/slot/slot";
import "./tab-actions.scss";

type Props = {
    tabs: PolicyDetailActionsTab[];
};

export type PolicyDetailActionsTab = {
    type: PolicyDetailActionsTabType;
    showWarning: boolean;
};

export enum PolicyDetailActionsTabType {
    Coverages = "Coberturas",
    Payments = "Pagos",
}

export const PolicyDetailTabActions: FC<Props> = ({ tabs, children }) => {
    const [tab, setTab] = useState(PolicyDetailActionsTabType.Coverages);

    const changeTab =
        (newTab: PolicyDetailActionsTabType) => (event: MouseEvent) => {
            event.preventDefault();
            setTab(newTab);
        };

    return (
        <div className="policyDetailTabActions">
            <header className="policyDetailTabActions__tabs">
                {tabs.map((inTab) => (
                    <a
                        key={inTab.type}
                        href="/"
                        className={cn(
                            "policyDetailTabActions__tab",
                            inTab.showWarning
                                ? "policyDetailTabActions__tab--warning"
                                : ""
                        )}
                        onClick={changeTab(inTab.type)}
                        data-active={inTab.type === tab}
                        style={{
                            width: 100 / tabs.length + "%",
                        }}
                    >
                        {inTab.type}
                    </a>
                ))}
            </header>
            <main className="policyDetailTabActions__contents">
                {tabs.map((inTab, index) => (
                    <div
                        key={`${inTab.type}-content`}
                        className="policyDetailTabActions__content"
                        data-active={inTab.type === tab}
                        style={{
                            left:
                                inTab.type === tab
                                    ? 0
                                    : `${
                                          100 * index -
                                          tabs.findIndex(
                                              (t) => t.type === tab
                                          ) *
                                              100
                                      }%`,
                        }}
                    >
                        <Slot name={inTab.type} content={children} />
                    </div>
                ))}
            </main>
        </div>
    );
};
